<h2 mat-dialog-title>Research Jobs</h2>
<mat-dialog-content>
  <p>Completed Jobs</p>
  <div class="job-cards">
    <mat-card *ngFor="let job of userJobs" class="job-card">
      <mat-card-title>{{ job.prompt_title }}</mat-card-title>
      <mat-card-content>
        <p>{{ job.user_prompt }}</p>
        <p>Collection: {{ job.collection }}</p>
        <p>Date Initiated: {{ job.started | date: 'MM/dd/yyyy' }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="openJobResult(job)">View Details</button>
        <button mat-button color="accent" (click)="publishJob(job)" *ngIf="!job.published">Publish</button>
        <button mat-button color="warn" (click)="unpublishJob(job)" *ngIf="job.published">Unpublish</button>
        <button mat-button color="warn" (click)="deleteJob(job)">Delete</button>
      </mat-card-actions>
    </mat-card>
  </div>

  <p *ngIf="ongoingJobs.length">Ongoing Jobs</p>
  <div class="job-cards">
    <mat-card *ngFor="let job of ongoingJobs" class="job-card">
      <mat-card-title>{{ job.prompt_title }}</mat-card-title>
      <mat-card-content>
        <p>{{ job.user_prompt }}</p>
        <p>Collection: {{ job.collection }}</p>
        <p>Status: {{ job.job_status }}</p>
        <p>Progress: {{ getProgressValue(job) }}%</p>
        <p>Date Initiated: {{ job.started | date: 'MM/dd/yyyy' }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="openJobResult(job)">View Results</button>
        <button mat-button color="warn" (click)="deleteJob(job)">Delete</button>
      </mat-card-actions>
    </mat-card>
  </div>

  <p>Published Research</p>
  <div class="job-cards">
    <mat-card *ngFor="let job of publishedJobs" class="job-card">
      <mat-card-title>{{ job.prompt_title }}</mat-card-title>
      <mat-card-content>
        <p>{{ job.user_prompt }}</p>
        <p>Collection: {{ job.collection }}</p>
        <p>Date Initiated: {{ job.started | date: 'MM/dd/yyyy' }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="openJobResult(job)">View Details</button>
      </mat-card-actions>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</mat-dialog-actions>
